// @ts-check
import CommandsPool from "@kaspernj/api-maker/build/commands-pool"

/** @typedef {import("models/school-class").default} SchoolClass */

/**
 * @typedef {object} BrainboundLaunchResult
 * @property {string} url
 */

/**
 * @param {SchoolClass} schoolClass - Class to launch in Brainbound.
 * @returns {Promise<BrainboundLaunchResult>} Brainbound redirect response.
 */
export default function brainboundLaunch(schoolClass) {
  return /** @type {Promise<BrainboundLaunchResult>} */ (CommandsPool.addCommand({
    args: {},
    command: "brainbound_launch",
    primaryKey: schoolClass.primaryKey(),
    collectionName: "school_classes",
    type: "member"
  }))
}
